export default "__VITE_ASSET__JUEiqtIZ__"